import React, { useEffect } from "react";
import { fetchGuidance } from "../../../states/actions/fetchGuidance";
import { useSelector, useDispatch } from "react-redux";
import LoadingScreen from "../../common/LoadingScreen";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import paths from "../../../constants/paths";
import Breadcrumb from "../../common/BreadCrumb";
import ImageControl from "../../common/ImageControl";
import Text from "../../common/Text";

const PreparationGuidance = () => {
  const { slug } = useParams();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.fetchGuidance.content);
  const isLoading = useSelector((state) => state.fetchGuidance.isLoading);
  const isSiteSettingsLoading = useSelector(
    (state) => state.fetchSiteSettings.isLoading,
  );
  // console.log("data", data);

  const { article, guidance_text = [], article_except = [] } = data;

  useEffect(() => {
    dispatch(fetchGuidance(slug));
  }, [slug, dispatch]);

  useDocumentTitle(data.page_title);

  const breadcrumbItems = [
    { name: "Dashboard", link: "/dashboard" },
    {
      name: article?.title,
      link: `${paths.SITE_BASE_URL}/preparation-guidance-details/${article?.slug}`,
    },
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(`guide-${id}`);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <>
      {isLoading || isSiteSettingsLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <ToastContainer />
          <section id="dash">
            <div className="contain">
              <div className="preparation_guidance">
                <Breadcrumb items={breadcrumbItems} />
                {/* <div className="btn_blk">
                  <a href="?" className="site_btn text">
                    <img src="/images/arrow-left-blue.svg" alt="" />
                    Back to Dashboard
                  </a>
                </div> */}
                <div className="icon_blk my-2">
                  <div
                    className="icon_img"
                    style={{ backgroundColor: article?.bg_color || "#dbeafe" }}
                  >
                    {article?.emoji || "✨"}
                  </div>
                  <span>{article?.sr_title}</span>
                </div>
                <h3>{article?.title}</h3>
                <p>{article?.short_desc}</p>
                {guidance_text?.length >= 2 && (
                  <div className="jump_to">
                    JUMP TO:
                    {guidance_text?.map((item) => (
                      <span
                        key={item?.id}
                        className="tag"
                        onClick={() => scrollToSection(item?.id)}
                        style={{ cursor: "pointer" }}
                      >
                        {item?.title}
                      </span>
                    ))}
                  </div>
                )}
                {guidance_text.map((item) => (
                  <React.Fragment key={item?.id}>
                    <div
                      id={`guide-${item?.id}`}
                      className="guide-section mt-5"
                    >
                      {item?.title && <h3>{item?.title}</h3>}
                      {item?.short_text && <p>{item?.short_text}</p>}
                      {item?.txt1 && (
                        <div className="inner">
                          <Text string={item?.txt1} />
                          {/* <blockquote>
                            <strong>Example visa status line</strong>
                            <p>
                              "Right to work: Skilled Worker visa sponsorship
                              required. Currently on a Graduate visa (expires
                              Jan 2027)."
                            </p>
                          </blockquote> */}
                        </div>
                      )}
                      {item?.txt2 && (
                        <div className="quick_check_list">
                          <div className="h6">QUICK CHECKLIST</div>
                          <Text string={item?.txt2} />
                          {/* <ul>
                            <li>
                              <strong>State visa status upfront</strong> — in
                              your summary or contact block — not buried.
                            </li>
                            <li>
                              <strong>Keep to 2 pages</strong> — achievements
                              over duties, quantified wherever possible.
                            </li>
                            <li>
                              <strong>Mirror the job description</strong> —
                              match its exact language for ATS keyword scans.
                            </li>
                            <li>
                              <strong>
                                Use a simple, single-column layout
                              </strong>{" "}
                              — so ATS parsers read it correctly.
                            </li>
                          </ul> */}
                        </div>
                      )}
                      {(item?.cta_heading ||
                        item?.cta_text ||
                        item?.cta_btn_text) && (
                        <div className="full_pic">
                          <div className="in">
                            {item?.cta_heading && <h5>{item?.cta_heading}</h5>}
                            {item?.cta_text && <p>{item?.cta_text}</p>}
                          </div>

                          {item?.cta_btn_text && (
                            <div className="btn_blk">
                              <a
                                href={item?.cta_btn_link || ""}
                                className="site_btn sm px-4"
                                target="_blank"
                              >
                                {item?.cta_btn_text} →
                              </a>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </React.Fragment>
                ))}
                <div className="other_guides">
                  <h6>OTHER FREE GUIDES</h6>
                  <div className="guide_tags">
                    {article_except?.map((item) => (
                      <a
                        key={item?.id}
                        href={`/preparation-guidance-details/${item?.slug}`}
                        className="guide_tag"
                      >
                        <span className="me-2">{item?.emoji || "✨"}</span>
                        {item?.title}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default PreparationGuidance;
